import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { generateMessageReturn } from "../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiPermissions extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "permissions";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  listGroup = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list/group`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Requisição de grupos de permissões",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  createGroup = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/group`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Criação de grupo de permissões",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  updateGroup = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/group`;
    this.config.method = "put";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Atualização de grupo de permissões",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  deleteGroup = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/group/${this.data.id_grupo_permissao}`;
    this.config.method = "delete";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Atualização de grupo de permissões",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  listPermissions = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list/${this.data.id_grupo_permissao}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Requisição de permissões",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  updatePermissions = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${this.data.id_grupo_permissao}`;
    this.config.method = "put";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Atualização de permissões",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  listUsers = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list/users`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Requisição de Usuários por grupo de permissões",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  updateUsers = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/users`;
    this.config.method = "put";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Atualização de permissões",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiPermissions;
